import type {MediaItem} from '@common/player/media-item';
import {nativePlaybackBridge} from '@common/core/capacitor/native-playback-bridge';
import {getBootstrapData} from '@ui/bootstrap-data/bootstrap-data-store';
import semver from 'semver';

const NATIVE_AUDIO_PLAYBACK_MIN_VERSION = '2.3.0';

export function canUseNativeAudioProvider(): boolean {
  return canUseNativePlaybackProvider(NATIVE_AUDIO_PLAYBACK_MIN_VERSION);
}

export function canUseNativeAudioPlaybackForMedia(
  media?: Pick<MediaItem, 'provider' | 'playerType'>,
): boolean {
  if (!media || media.playerType === 'video') {
    return false;
  }

  return (
    canUseNativeAudioProvider() &&
    (media.provider === 'htmlAudio' ||
      media.provider === 'hlsAudio' ||
      media.provider === 'dashAudio')
  );
}

export function canUseNativeAudioPlaybackForQueue(
  queue?: Array<Pick<MediaItem, 'provider' | 'playerType'>>,
): boolean {
  return Boolean(
    queue?.length && queue.every(item => canUseNativeAudioPlaybackForMedia(item)),
  );
}

function getAppVersion(): string | undefined {
  const settings = getBootstrapData()?.settings as {version?: string} | undefined;
  return settings?.version;
}

function canUseNativePlaybackProvider(minVersion: string): boolean {
  if (!nativePlaybackBridge.isSupported()) {
    return false;
  }

  const appVersion = getAppVersion();
  if (!appVersion || !semver.valid(appVersion)) {
    return false;
  }

  return semver.gte(appVersion, minVersion);
}
